// store.js
import { configureStore } from '@reduxjs/toolkit';

import { challengesApiSlice } from '../challenges/challengesApiSlice';
import challengesReducer from '../challenges/challengesSlice';
import { mediaApiSlice } from '../contentTypes/mediaApiSlice';
import mediaReducer from '../contentTypes/mediaSlice';
import { mediaSlidersApiSlice } from '../forYou/mediaSlidersApiSlice';
import mediaSlidersReducer from '../forYou/mediaSlidersSlice';
import { goalsApiSlice } from '../goals/goalsApiSlice'; // import your goals api slice
import goalsReducer from '../goals/goalsSlice'; // import your goals slice
import { userApiSlice } from '../profile/userApiSlice'; // import your user api slice
import userReducer from '../profile/userSlice'; // import your user slice

export default configureStore({
  reducer: {
    user: userReducer,
    goals: goalsReducer,
    mediaSliders: mediaSlidersReducer,
    media: mediaReducer,
    challenges: challengesReducer,
    [userApiSlice.reducerPath]: userApiSlice.reducer,
    [goalsApiSlice.reducerPath]: goalsApiSlice.reducer,
    [mediaSlidersApiSlice.reducerPath]: mediaSlidersApiSlice.reducer,
    [mediaApiSlice.reducerPath]: mediaApiSlice.reducer,
    [challengesApiSlice.reducerPath]: challengesApiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(userApiSlice.middleware)
      .concat(goalsApiSlice.middleware)
      .concat(mediaSlidersApiSlice.middleware)
      .concat(mediaApiSlice.middleware)
      .concat(challengesApiSlice.middleware),
});
